import { on } from 'delegated-events';
import abort from '../../../javascripts/utils/abort';

on('click', '.image-teaser-slider__navigation button[data-move]', (event) => {
  const { currentTarget: $button } = event;
  const { move } = $button.dataset;

  event.preventDefault();

  const $slider = $button.closest('.image-teaser-slider') ?? abort();
  const $teasers = $slider.querySelector<HTMLElement>('.image-teaser-slider__teasers') ?? abort();

  if (move === 'left') {
    $teasers.scrollBy({ left: $teasers.clientWidth * -1 });
  } else if (move === 'right') {
    $teasers.scrollBy({ left: $teasers.clientWidth });
  }
});

on('click', 'button.image-teaser-slider__dot', (event) => {
  const { currentTarget: $button } = event;
  const { moveTo } = $button.dataset;

  event.preventDefault();

  const $slider = $button.closest('.image-teaser-slider') ?? abort();
  const $teasers = $slider.querySelector<HTMLElement>('.image-teaser-slider__teasers') ?? abort();
  const $$teaser = $teasers.querySelectorAll<HTMLElement>('.image-teaser-slider__teaser');

  const teaserIndex = parseInt(moveTo ?? '0', 10);
  const $teaser = $$teaser[teaserIndex];

  $teasers.scrollTo({ left: $teaser.offsetLeft - $teasers.offsetLeft });
});

document.querySelectorAll<HTMLElement>('.image-teaser-slider').forEach(($slider) => {
  const $teasers = $slider.querySelector<HTMLElement>('.image-teaser-slider__teasers') ?? abort();
  const $$teaser = $teasers.querySelectorAll<HTMLElement>('.image-teaser-slider__teaser');
  const $$dot = $slider.querySelectorAll<HTMLElement>('.image-teaser-slider__dot');
  const $$moveLeft = $slider.querySelectorAll<HTMLButtonElement>('[data-move="left"]');
  const $$moveRight = $slider.querySelectorAll<HTMLButtonElement>('[data-move="right"]');

  $teasers.scrollTo({ left: 0, behavior: 'instant' });
  $teasers.addEventListener('scroll', () => {
    const currentIndex = Array.from($$teaser).findIndex(($teaser) => {
      const offsetLeft = $teaser.offsetLeft - $teasers.offsetLeft;
      return offsetLeft >= $teasers.scrollLeft;
    });

    $$dot.forEach(($dot, index) => {
      $dot.setAttribute('aria-current', index === currentIndex ? 'true' : 'false');
    });

    $$moveLeft.forEach(($moveLeft) => {
      $moveLeft.disabled = $teasers.scrollLeft <= 5;
    });

    $$moveRight.forEach(($moveRight) => {
      $moveRight.disabled = $teasers.scrollLeft >= ($teasers.scrollWidth - $teasers.clientWidth - 5);
    });
  }, { passive: true });
});
